import useTranslation from "next-translate/useTranslation"

import { IChallenge } from "@api/schema"
import { challengeLogoPlaceholder, challengeTranslation } from "@services/challengeHelper"
import { isFund, fundLogoPlaceholder } from "@services/fundHelper"
import { prefixApiUrl } from "@services/util"

interface IProps {
  challenge: IChallenge
  className?: string
  height?: number
  width?: number
}

/**
 * Shows the challenge logo dependent on the challenge type
 */
const ChallengeLogo = ({ challenge, className, height, width }: IProps): JSX.Element => {
  const { t } = useTranslation("common")

  return <img
    src={challenge.logo
      ? prefixApiUrl(challenge.logo.contentUrl)
      : isFund(challenge)
        ? fundLogoPlaceholder
        : challengeLogoPlaceholder}
    alt={challenge.logo
      ? challenge.name
      : challengeTranslation("challenge.logo.placeholder", challenge["@type"], t)}
    className={className ? className : "challenge-logo"}
    height={height}
    width={width}
  />
  {/* @todo responsive
        <Image
            src={challenge.logo
                ? prefixApiUrl(challenge.logo.contentUrl)
                : challengeLogoPlaceholder}
            alt={challenge.logo
                ? challenge.logo.originalName
                : t("challenge.logo.placeholder")}
            height={100}
            width={100}
            objectFit="none"
            className="challenge-logo"
    />*/}
}

export default ChallengeLogo